import alt from 'components/Dispatcher';

class FileUploadNewCallActions {
  constructor() {
    this.generateActions(
      'clearState',
      'clearUploadErrorAndProgress',
      'updateCloseNewCallDialog',
      'updateFileUploadMetadata',
      'updateFileUploadMetadataError',
      'updateFileUploadMetadataSuccess',
      'uploadFile',
      'uploadFileError',
      'uploadFileInProgress',
      'uploadFileSuccess'
    );
  }
}

export default alt.createActions(FileUploadNewCallActions);
